import React from 'react';
import AutoSaveDropdown from 'components/forms/AutoSaveFormFields/AutoSaveDropdown.jsx';
import {isNoU} from "../../../utils/DBUtils";
import {FormattedMessage} from 'react-intl';

{/* We need a custom component to gather the options from a proxy to populate
    the dropdown to select a result for various answers */}
class ColorPaletteDropdown extends React.Component {

    constructor(props) {
      super(props);
    }

    getValueFromOnChange = (event, data) => {
      return data.value;
    };

    get paletteOptions () {
      let palettes = this.props.options;
      let options = [];

      if ( !isNoU(palettes) ) {
        for(let i=0;i<palettes.length;i++) {
          options.push({
            text: palettes[i].name,
            value: palettes[i],
            key: i
          });
        }
      }
      // console.log(options);
      return options;
    }

    render() {
        return (
          <div className="db-color-palette">
          <AutoSaveDropdown placeholder={<FormattedMessage id='editbreak.colors.colorPalette'/>}
                            name={this.props.name}
                            currentPlatform={this.props.currentPlatform}
                            onPersistValue={(palette) =>  this.props.setPalette(this.props.breakId,palette)}
                            fieldLabel={this.props.fieldLabel}
                            options={this.paletteOptions}
                            helpContent={this.props.helpContent}
                            helpHeader={this.props.helpHeader}
                            required={this.props.required}
                            selectOnBlur={false}
                            selectOnNavigation={false}
                           />
          </div>
        )
    }
}

ColorPaletteDropdown.propTypes = {

};

export default ColorPaletteDropdown;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/ColorPaletteDropdown.jsx